// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"xg-z","itemsContainer":"yg-z"};